jQuery(document).ready(function(){
  outgoTrack(productId, 'product', 'view');
  jQuery('.add-to-cart-block .action_button.add_to_cart').on('click', outgoTrack(productId, 'product', 'add-to-cart'));
});

function outgoTrack(resId, eventCategory, eventAction){
  jQuery.ajax({
    url: 'https://claim.outgo.com/api/webhook/products.php',
    type: 'get',
    dataType: 'json',
    data: {
      'a': 'event',
      'category': eventCategory,
      'action': eventAction,
      'product': resId
    },
    success: function(data){
      // do nothing
      // console.log(data);
    },
    error: function(data){
      // do nothing
      // console.error(data);
    }
  });
}
